import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Person} from '../Person';
import {CandidatServiceService} from '../Service/candidat-service.service';
import {ApiServiceService} from '../Service/api-service.service';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-profile-candidate',
    templateUrl: './ProfileCandidate.component.html',
    styleUrls: ['./ProfileCandidate.component.css']
})
export class ProfileCandidateComponent implements OnInit {
    result: any;
    filings: Observable<object[]>;
    committee: Observable<object[]>;

    constructor(private route: ActivatedRoute,
                private  candidatServiceService: CandidatServiceService,
                private apiServiceService: ApiServiceService
    ) {
    }


    getCandidate(): void {
        const id = this.route.snapshot.paramMap.get('id');
        console.log(id);
        this.apiServiceService.getDetailSearch(id.toString()).subscribe(Result => this.result = Result['results']);
    }

    getListFilings(): void {
        const id = this.route.snapshot.paramMap.get('id');
        this.apiServiceService.getCandidateFilings(id.toString()).subscribe(Result => this.filings = Result['results']);
    }

    getListCommittee(): void {
        const id = this.route.snapshot.paramMap.get('id');
        this.apiServiceService.getCandidateCommittee(id.toString()).subscribe(Result => this.committee = Result['results']);
    }

    ngOnInit() {
        this.getCandidate();
        this.getListFilings();
        this.getListCommittee();
    }



}
